import SUPPORTS from './supports'

import type { languageCodes, subtitleResolutions, videoResolutions } from './util'

import { DEFAULT_MINING_AUDIO_SOURCES, type MiningAudioPlaybackMode, type MiningAudioSource } from '$lib/modules/mining/audio'
import { DEFAULT_MINING_DICTIONARY_CSS } from '$lib/modules/mining/dictionary'
import { DEFAULT_MINING_MEDIA_SETTINGS } from '$lib/modules/mining/media/settings'
import { DEFAULT_MINING_SUBTITLE_CSS } from '$lib/modules/mining/subtitle'

export default {
  volume: 1,
  playerAutoplay: true,
  playerAutoPiP: false,
  playerPause: true,
  playerAutocomplete: true,
  playerDeband: false,
  playerCustom: SUPPORTS.isMobile && !(SUPPORTS.isAndroidTV && SUPPORTS.isUnderPowered),
  subtitleStyle: 'none' as 'none' | 'gandhisans' | 'notosans' | 'roboto' | 'custom',
  subtitleCustomFontName: '',
  subtitleAutoRetiming: true,
  playerSubtitleSelection: null as null | {
    off: boolean
    language?: string
    name?: string
    number?: string
  },
  miningModeActive: false,
  miningHideSubtitles: false,
  miningPauseOnEnter: false,
  miningPauseOnLookup: true,
  miningNestedPopupOnHover: true,
  miningSubtitleCss: DEFAULT_MINING_SUBTITLE_CSS,
  miningPopupWidth: 500,
  miningPopupHeight: 400,
  miningPopupScale: 1.5,
  miningDictionaryScanNonJapanese: false,
  miningDictionaryMaxResults: 16,
  miningDictionaryScanLength: 16,
  miningDictionaryCollapseMode: 'expandAll' as 'expandAll' | 'collapseAll',
  miningDictionaryExpandFirst: false,
  miningDictionaryCompactGlossaries: true,
  miningDictionaryShowExpressionTags: false,
  miningDictionaryCss: DEFAULT_MINING_DICTIONARY_CSS,
  miningDictionaryOuterCss: '',
  miningAudioSources: DEFAULT_MINING_AUDIO_SOURCES.map(source => ({ ...source })) as MiningAudioSource[],
  miningAudioAutoplay: false,
  miningAudioPlaybackMode: 'interrupt' as MiningAudioPlaybackMode,
  miningAudioUsePlayerVolume: false,
  miningAudioVolume: 1,
  miningAnkiCaptureScreenshot: true,
  miningAnkiImageMode: DEFAULT_MINING_MEDIA_SETTINGS.imageMode as 'static' | 'animated',
  miningAnkiStaticImageFormat: DEFAULT_MINING_MEDIA_SETTINGS.staticImageFormat as 'png' | 'jpeg' | 'webp' | 'avif',
  miningAnkiAnimatedImageFormat: DEFAULT_MINING_MEDIA_SETTINGS.animatedImageFormat as 'webp' | 'avif',
  miningAnkiMediaQuality: DEFAULT_MINING_MEDIA_SETTINGS.quality as 'fast' | 'balanced' | 'high',
  miningAnkiImageMaxHeight: DEFAULT_MINING_MEDIA_SETTINGS.maxHeight,
  miningAnkiAnimationFps: DEFAULT_MINING_MEDIA_SETTINGS.animationFps,
  miningAnkiSyncAnimationToWordAudio: DEFAULT_MINING_MEDIA_SETTINGS.syncAnimationToWordAudio,
  miningAnkiCaptureAudio: true,
  miningAnkiAudioPaddingStart: 0.15,
  miningAnkiAudioPaddingEnd: 0.15,
  searchQuality: '1080' as keyof typeof videoResolutions,
  searchAutoSelect: true,
  lookupPreference: 'quality' as 'quality' | 'size' | 'seeders',
  torrentSpeed: 40,
  torrentPersist: false,
  torrentDHT: false,
  torrentPeX: false,
  torrentPort: 0,
  torrentStreamedDownload: true,
  dhtPort: 0,
  maxConns: 80,
  subtitleRenderHeight: SUPPORTS.isMobile ? '720' : '0' as keyof typeof subtitleResolutions,
  subtitleLanguage: 'eng' as keyof typeof languageCodes,
  audioLanguage: 'jpn' as keyof typeof languageCodes,
  enableDoH: false,
  hideToTray: false,
  doHURL: 'https://cloudflare-dns.com/dns-query',
  showDetailsInRPC: true,
  showNavigation: false,
  torrentPath: '',
  angle: 'default' as 'default' | 'd3d11'| 'd3d9' | 'warp' | 'gl' | 'gles' | 'swiftshader' | 'vulkan' | 'metal',
  uiScale: 1,
  titleType: 'ANILIST' as 'ANILIST' | 'ROMAJI' | 'ENGLISH' | 'NATIVE',
  enableExternal: false,
  playerPath: '',
  playerSeek: '2',
  playerSkip: false,
  playerSkipFiller: false,
  minimalPlayerUI: false,
  androidStorageType: 'cache',
  showHentai: false,
  hideSpoilers: false,
  theme: 'default' as 'default' | 'light' | 'catppuccin' | 'dracula' | 'amber' | 'lavender' | 'system' | 'custom',
  customThemeColors: {
    '--custom-background': '#000000',
    '--custom-foreground': '#fafafa',
    '--custom-muted': '#0a0a0a',
    '--custom-muted-foreground': '#7f7f7f',
    '--custom-card': '#0a0a0a',
    '--custom-card-foreground': '#fafafa',
    '--custom-popover': '#0a0a0a',
    '--custom-popover-foreground': '#fafafa',
    '--custom-border': '#262626',
    '--custom-input': '#333333',
    '--custom-primary': '#fafafa',
    '--custom-primary-foreground': '#1a1a1a',
    '--custom-secondary': '#2a2a2a',
    '--custom-secondary-foreground': '#fafafa',
    '--custom-accent': '#141414',
    '--custom-accent-foreground': '#fafafa',
    '--custom-destructive': '#7f1d1d',
    '--custom-destructive-foreground': '#fafafa',
    '--custom-ring': '#d4d4d4'
  },
  nzbDomain: '',
  nzbLogin: '',
  nzbPassword: '',
  nzbPort: 119,
  nzbPoolSize: 4
}
